var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerDefaultOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 56,
  viewBox: "0 0 34 56"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "marker-outline",
  fillRule: "nonzero",
  stroke: "#F8E71C",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M22.73 31.943 17.055 46.6 11.4 31.993A16.01 16.01 0 0 1 1 17C1 8.163 8.163 1 17 1s16 7.163 16 16c0 6.66-4.12 12.588-10.27 14.943z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "marker-color",
  fill: "#CCC",
  stroke: "#BBB",
  d: "M9.55 27.804A14.51 14.51 0 0 1-.5 14C-.5 5.992 5.992-.5 14-.5S28.5 5.992 28.5 14a14.51 14.51 0 0 1-9.922 13.762l-4.522 11.682-4.507-11.64z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 6,
  fill: "#FFF"
})))));
export default SvgMarkerDefaultOn;